/**
 * ZyngaButton.js
 * Extension of buttons lib specifically with Zynga
 * standard logo and text.
 * @author Jaiwardhan Swarnakar
 */
import React from 'react';
import { Link } from "react-router-dom";
import './Buttons.css'
import Button from './Buttons';
import BaseComponent from '../../BaseComponent';

function getButtonClass(severity, extraClass, forceClass) {
    let options = {
        "default": " btn button-zynga "
    }
    severity = !severity || !(severity in options)
        ? "default"
        : severity;
    let result = options[severity];
    if (extraClass) {
        result = result + " " + extraClass;
    }
    if (forceClass) {
        result = forceClass;
    }
    return result;
}

class GenericButton extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {

        return (
            <div type="button" onClick={this.props.onClick} className={getButtonClass(
                this.props.severity,
                this.props.extraClass,
                this.props.forceClass
            )} name={this.props.name ? this.props.name : ""}
                data-toggle={this.props.toggle ? this.props.toggle : ""}
                data-target={this.props.target ? this.props.target : ""}>
                <div className="row no-gutters">
                    <div className="col">
                        <img alt="zynga-play" className="button-logo"
                            src={process.env.REACT_APP_ASSET_PATH + "/zynga-logo.png"} />
                        <span className="button-text-white">
                            {this.props.message}
                        </span>
                    </div>
                </div>

            </div>
        )
    }
}

class LinkButton extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {};
        if (!this.props.to) {
            super.fatal("Unable to render Link without a 'to' property");
        }
        this.onClick = this.props.onClick ? this.props.onClick : () => { };
    }

    render() {
        return (
            <Link
                className={getButtonClass(
                    this.props.severity,
                    this.props.extraClass,
                    this.props.forceClass
                )}
                to={this.props.to}
                onClick={this.onClick}
            >
                <div className="row no-gutters">
                    <div className="col">
                        <img alt="zynga-play" className="button-logo"
                            src={process.env.REACT_APP_ASSET_PATH + "/zyngaLogoWhite.png"} />
                        <span className="button-text-white">
                            {this.props.message}
                        </span>
                    </div>
                </div>
            </Link>
        )
    }
}

/**
 * Generic button class that can behave as base <a> or
 * a react <Link> component based on passed props.
 * Input schema:
 * @param {String}  type        link|*  renders as a <Link> or <a>
 * @param {String}  severity    default|info|action renders the appropriate button style
 * @param {String} extraClass   *   Space separated classes to apply
 * @param {String} forceClass   *   Space separated classes to override all button.css classes
 * @returns {Button}
 */
class ZyngaButton extends Button {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        const buttonDetect = (bProps) => {
            if (bProps.type === "link") {
                return <LinkButton {...this.props} {...bProps} />
            }

            return <GenericButton {...this.props} {...bProps} />
        }
        return (
            buttonDetect(this.props)
        )
    }
}

export default ZyngaButton;